import { useState, createContext, useContext } from 'react';

// Create context to share modal state across components
const DemoModalContext = createContext();

// Provider component that wraps your app and makes modal state available
export function DemoModalProvider({ children }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <DemoModalContext.Provider value={{ isModalOpen, openModal, closeModal }}>
      {children}
    </DemoModalContext.Provider>
  );
}

// Hook to use the demo modal context
export function useDemoModal() {
  const context = useContext(DemoModalContext);
  if (context === undefined) {
    throw new Error('useDemoModal must be used within a DemoModalProvider');
  }
  return context;
}